import React, { useContext, useEffect, useState } from 'react'
import { FeedItem } from '../../../../../Api'
import { SectionHeading } from '../../../../../Components/Headers'
import { AdditionalVidSection } from '../styles'
import { AdditionalVideo } from './AdditionalVideo'
import { VideoGroupContext } from '../../../../../Context/VideoContext/VideoGroupContext'

export const AdditionalVideos: React.FC = () => {
  const { additionalVideos, onSelectVideo, tag } = useContext(VideoGroupContext)!

  const [addVids, setAddVids] = useState<FeedItem[]>([])

  useEffect(() => {
    setAddVids(additionalVideos)
  }, [additionalVideos])

  return (
    <AdditionalVidSection>
      {addVids.length > 0 && (
        <>
          <SectionHeading headingText="More Videos For You" headingColor="light" />
          {addVids.map((vid, idx) => (
            <AdditionalVideo
              key={vid.mediaId}
              video={vid}
              onSelect={onSelectVideo}
              videoIdx={idx}
              tag={tag}
            />
          ))}
        </>
      )}
    </AdditionalVidSection>
  )
}
